// Activity column button renderer component
import { Component } from "@angular/core";

@Component({
    selector: "sms-button-renderer",
    template: ` <a href="#" (click)="onClick($event)">{{ label }}</a> `,
    standalone: true
})
export class ButtonRenderComponent {
  params;
  label: string;

  agInit(params): void {
    this.params = params;
    this.label = this.params.value || null;
  }

  onClick($event) {
    try {
      // put anything into params u want pass into parents component

      console.log($event);
      const params = {
        event: $event,
        rowData: this.params
      };
      this.params.onClick(params.rowData);
    } catch (error) {
      console.error(error);
    }
  }
}
